/**
 * Wacht dit scherm nog echt op gegevens?
 *
 * `isPending` alleen zegt "er zijn nog geen gegevens", ook bij een query die uitgeschakeld is
 * (`enabled: false`) en dus nooit iets zal ophalen: wie geen lijn of geen teamrecht heeft, zag daardoor
 * eindeloos een laadscherm (testrapport 28 okt. 2026, #14). Een uitgeschakelde query staat op
 * `fetchStatus: 'idle'`; een die haalt of offline gepauzeerd is, niet.
 */
export function isAwaitingData(query: { isPending: boolean; fetchStatus: string }): boolean {
  return query.isPending && query.fetchStatus !== 'idle';
}
